// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_fancybox.js"; import "./autoload/_slick-carousel.js";
import browser from "browser-detect";
jQuery.noConflict();

/*function windowWidth() {
  var e = window,
    a = "inner";
  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  var windowWidth = e[a + "Width"];
  return windowWidth;
}*/

// function windowHeight() {
//   var e = window,
//     a = "inner";
//   if (!("innerHeight" in window)) {
//     a = "client";
//     e = document.documentElement || document.body;
//   }
//   var windowHeight = e[a + "Height"];
//   return windowHeight;
// }

jQuery(document).ready(() => {
  jQuery("#front-slider").slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
  });

  jQuery(".carousel-nav").slick({
    speed: 600,
  });
  jQuery(".carousel-inner").slick({
    speed: 600,
  });

  jQuery(".js-popup-iframe").magnificPopup({
    type: "iframe",
    iframe: {
      patterns: {
        youtube: {
          id: "",
          src: "%id%",
        },
      },
    },
  });

  jQuery("iframe:visible").each(function() {
    var width = jQuery(this).attr("width");
    var height = jQuery(this).attr("height");
    jQuery(this).addClass("embed-responsive-item");
    jQuery(this)
      .parent("p")
      .addClass("embed-responsive");
    if (width / height > 1.5) {
      jQuery(this)
        .parent("p")
        .addClass("embed-responsive-16by9");
    } else {
      jQuery(this)
        .parent("p")
        .addClass("embed-responsive-4by3");
    }
  });

  jQuery(".js-scroll-to").on("click", function(e) {
    var target = jQuery(jQuery(this).attr("href"));
    if (target.length) {
      e.preventDefault();
      jQuery("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        500
      );
    }
  });

  /**filter*/
  function addIconLoading() {
    jQuery("#car-list").html(
      '<li class="wrap-icon-loading"><span class="icon-loading"></span></li>'
    );
  }

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[[]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function replaceUrlParam(url, paramName, paramValue) {
    if (url.indexOf(paramName + "=") >= 0) {
      var prefix = url.substring(0, url.indexOf(paramName));
      var suffix = url.substring(url.indexOf(paramName));

      suffix = suffix.substring(suffix.indexOf("=") + 1);
      suffix =
        suffix.indexOf("&") >= 0 ? suffix.substring(suffix.indexOf("&")) : "";

      if (paramValue) {
        url = prefix + paramName + "=" + paramValue + suffix;
      } else {
        url = prefix + suffix;
      }

      if (url.indexOf("&&") >= 0) {
        url = url.replace("&&", "&");
      }

      if (url[url.length - 1] === "&") {
        url = url.slice(0, -1);
      }

      if (url.indexOf(paramName + "?&") >= 0) {
        url = url.replace("?&", "?");
      } else if (url.indexOf(paramName + "&?") >= 0) {
        url = url.replace("&?", "?");
      } else if (url.indexOf("?&") >= 0) {
        url = url.replace("?&", "?");
      } else if (url.indexOf("&?") >= 0) {
        url = url.replace("&?", "?");
      }

      if (url.indexOf("?") == url.length - 1) {
        url = url.replace("?", "");
      }
    } else if (paramValue) {
      if (url.indexOf("?") < 0) url += "?" + paramName + "=" + paramValue;
      else {
        if (url.indexOf("?") === url.length - 1) {
          url += paramName + "=" + paramValue;
        } else {
          url += "&" + paramName + "=" + paramValue;
        }
      }
    }

    return url;
  }

  var job_functie;
  var regio;
  var werkveld;
  var werkverband;
  var newURL = window.location.href;
  var currentURL_Parts_obj = {
    job_functie: getParameterByName("job_functie", newURL),
    regio: getParameterByName("regio", newURL),
    werkveld: getParameterByName("werkveld", newURL),
    werkverband: getParameterByName("werkverband", newURL),
  };

  if (
    currentURL_Parts_obj.job_functie !== null ||
    currentURL_Parts_obj.regio !== null ||
    currentURL_Parts_obj.werkveld !== null ||
    currentURL_Parts_obj.werkverband !== null
  ) {
    jQuery("#car-list").addClass("hidden");

    jQuery(".tax-filter option").each(function() {
      if (
        jQuery(this).attr("name") === "job_functie" &&
        jQuery(this).attr("value") === currentURL_Parts_obj.job_functie
      ) {
        jQuery(this).prop("selected", true);
      } else {
        jQuery(this).prop("selected", false);
      }

      if (
        jQuery(this).attr("name") === "regio" &&
        jQuery(this).attr("value") === currentURL_Parts_obj.regio
      ) {
        jQuery(this).prop("selected", true);
      } else {
        jQuery(this).prop("selected", false);
      }

      if (
        jQuery(this).attr("name") === "werkveld" &&
        jQuery(this).attr("value") === currentURL_Parts_obj.werkveld
      ) {
        jQuery(this).prop("selected", true);
      } else {
        jQuery(this).prop("selected", false);
      }

      if (
        jQuery(this).attr("name") === "werkverband" &&
        jQuery(this).attr("value") === currentURL_Parts_obj.werkverband
      ) {
        jQuery(this).prop("selected", true);
      } else {
        jQuery(this).prop("selected", false);
      }
    });

    if (currentURL_Parts_obj.job_functie !== null) {
      jQuery(".cat_job_functie").val(currentURL_Parts_obj.job_functie);
    } else {
      jQuery(".cat_job_functie").val("all");
      jQuery(".cat_job_functie option")
        .first()
        .prop("selected", true);
    }

    if (currentURL_Parts_obj.regio !== null) {
      jQuery(".cat_regio").val(currentURL_Parts_obj.regio);
    } else {
      jQuery(".cat_regio").val("all");
      jQuery(".cat_regio option")
        .first()
        .prop("selected", true);
    }

    if (currentURL_Parts_obj.werkveld !== null) {
      jQuery(".cat_werkveld").val(currentURL_Parts_obj.werkveld);
    } else {
      jQuery(".cat_werkveld").val("all");
      jQuery(".cat_werkveld option")
        .first()
        .prop("selected", true);
    }

    if (currentURL_Parts_obj.werkverband !== null) {
      jQuery(".cat_werkverband").val(currentURL_Parts_obj.werkverband);
    } else {
      jQuery(".cat_werkverband").val("all");
      jQuery(".cat_werkverband option")
        .first()
        .prop("selected", true);
    }

    jQuery
      .ajax({
        beforeSend: addIconLoading,
        type: "post",
        dataType: "json",
        url: themeVars.ajaxurl,
        data: {
          action: "lekz_job_tax_filter",
          job_functie: currentURL_Parts_obj.job_functie,
          regio: currentURL_Parts_obj.regio,
          werkveld: currentURL_Parts_obj.werkveld,
          werkverband: currentURL_Parts_obj.werkverband,
        },
      })
      .done(function(response) {
        jQuery("#car-list").html(response.data);
        jQuery("#car-list").removeClass("hidden");
      });
  }

  if (jQuery("#car-list").length > 0) {
    history.pushState(currentURL_Parts_obj, "Filtered", newURL);
  }

  jQuery(".tax-filter").on("change", function() {
    jQuery(".tax-filter option:selected").each(function() {
      if (jQuery(this).attr("name") === "job_functie") {
        job_functie = jQuery(this).val();

        if (job_functie !== "all") {
          newURL = replaceUrlParam(newURL, "job_functie", job_functie);
          currentURL_Parts_obj.job_functie = job_functie;
        } else {
          newURL = replaceUrlParam(newURL, "job_functie", "");
          currentURL_Parts_obj.job_functie = null;
        }
      }
      if (jQuery(this).attr("name") === "regio") {
        regio = jQuery(this).val();

        if (regio !== "all") {
          newURL = replaceUrlParam(newURL, "regio", regio);
          currentURL_Parts_obj.regio = regio;
        } else {
          newURL = replaceUrlParam(newURL, "regio", "");
          currentURL_Parts_obj.regio = null;
        }
      }
      if (jQuery(this).attr("name") === "werkveld") {
        werkveld = jQuery(this).val();

        if (werkveld !== "all") {
          newURL = replaceUrlParam(newURL, "werkveld", werkveld);
          currentURL_Parts_obj.werkveld = werkveld;
        } else {
          newURL = replaceUrlParam(newURL, "werkveld", "");
          currentURL_Parts_obj.werkveld = null;
        }
      }
      if (jQuery(this).attr("name") === "werkverband") {
        werkverband = jQuery(this).val();

        if (werkverband !== "all") {
          newURL = replaceUrlParam(newURL, "werkverband", werkverband);
          currentURL_Parts_obj.werkverband = werkverband;
        } else {
          newURL = replaceUrlParam(newURL, "werkverband", "");
          currentURL_Parts_obj.werkverband = null;
        }
      }
    });

    jQuery
      .ajax({
        beforeSend: addIconLoading,
        type: "post",
        dataType: "json",
        url: themeVars.ajaxurl,
        data: {
          action: "lekz_job_tax_filter",
          job_functie: job_functie,
          regio: regio,
          werkveld: werkveld,
          werkverband: werkverband,
        },
      })
      .done(function(response) {
        jQuery("#car-list").html(response.data);
        history.pushState(currentURL_Parts_obj, "Filtered", newURL);
      });
  });

  jQuery(window).on("popstate", function(e) {
    currentURL_Parts_obj = e.originalEvent.state;

    if (currentURL_Parts_obj !== null && currentURL_Parts_obj !== undefined) {
      jQuery(".tax-filter option").each(function() {
        if (
          jQuery(this).attr("name") === "job_functie" &&
          jQuery(this).attr("value") === currentURL_Parts_obj.job_functie
        ) {
          jQuery(this).prop("selected", true);
        } else {
          jQuery(this).prop("selected", false);
        }

        if (
          jQuery(this).attr("name") === "regio" &&
          jQuery(this).attr("value") === currentURL_Parts_obj.regio
        ) {
          jQuery(this).prop("selected", true);
        } else {
          jQuery(this).prop("selected", false);
        }

        if (
          jQuery(this).attr("name") === "werkveld" &&
          jQuery(this).attr("value") === currentURL_Parts_obj.werkveld
        ) {
          jQuery(this).prop("selected", true);
        } else {
          jQuery(this).prop("selected", false);
        }

        if (
          jQuery(this).attr("name") === "werkverband" &&
          jQuery(this).attr("value") === currentURL_Parts_obj.werkverband
        ) {
          jQuery(this).prop("selected", true);
        } else {
          jQuery(this).prop("selected", false);
        }
      });

      if (currentURL_Parts_obj.job_functie !== null) {
        jQuery(".cat_job_functie").val(currentURL_Parts_obj.job_functie);
      } else {
        jQuery(".cat_job_functie").val("all");
        jQuery(".cat_job_functie option")
          .first()
          .prop("selected", true);
      }

      if (currentURL_Parts_obj.regio !== null) {
        jQuery(".cat_regio").val(currentURL_Parts_obj.regio);
      } else {
        jQuery(".cat_regio").val("all");
        jQuery(".cat_regio option")
          .first()
          .prop("selected", true);
      }

      if (currentURL_Parts_obj.werkveld !== null) {
        jQuery(".cat_werkveld").val(currentURL_Parts_obj.werkveld);
      } else {
        jQuery(".cat_werkveld").val("all");
        jQuery(".cat_werkveld option")
          .first()
          .prop("selected", true);
      }

      if (currentURL_Parts_obj.werkverband !== null) {
        jQuery(".cat_werkverband").val(currentURL_Parts_obj.werkverband);
      } else {
        jQuery(".cat_werkverband").val("all");
        jQuery(".cat_werkverband option")
          .first()
          .prop("selected", true);
      }

      jQuery
        .ajax({
          beforeSend: addIconLoading,
          type: "post",
          dataType: "json",
          url: themeVars.ajaxurl,
          data: {
            action: "lekz_job_tax_filter",
            job_functie: currentURL_Parts_obj.job_functie,
            regio: currentURL_Parts_obj.regio,
            werkveld: currentURL_Parts_obj.werkveld,
            werkverband: currentURL_Parts_obj.werkverband,
          },
        })
        .done(function(response) {
          jQuery("#car-list").html(response.data);
        });
    }
  });

  /** browserDetect function */
  var $browser = browser();
  jQuery("body").addClass($browser.name);

  /** browserDetect function end */
});

jQuery(window).load(() => {
  jQuery(".front-slider").on("setPosition", function() {
    jQuery(this)
      .find(".slick-slide")
      .height("auto");
    var slickTrack = jQuery(this).find(".slick-track");
    var slickTrackHeight = jQuery(slickTrack).height();
    jQuery(this)
      .find(".slick-slide")
      .css("height", slickTrackHeight + "px");
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js